//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { connect } from "react-redux";
// auth-permission-info-card imports
import { IContainer, IProps, IState } from "./AuthPermissionInfoCard.d";
import { styles } from "./AuthPermissionInfoCard.styles";
// other imports
import { H3, A } from "@ui";
// state
import { IReduxState } from "@reducers/root.reducer";
// util
import { paths } from "@constants/site.constant";
// material-ui
import withStyles from "@material-ui/core/styles/withStyles";
import { IconButton } from "@material-ui/core";
import { Close } from "@material-ui/icons";

//////////////////
// COMPONENT
//////////////////
class AuthPermissionInfoCardCmpt extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      hidden: !!props.hidden,
    };
  }

  public UNSAFE_componentWillReceiveProps(nextProps: IProps) {
    if (!!nextProps.hidden !== this.state.hidden) {
      this.setState({ hidden: !!nextProps.hidden });
    }
  }

  // ~-~-~-~-~-~-~-
  // Heleprs
  // ~-~-~-~-~-~-~-
  private onClose = () => {
    this.setState({ hidden: true });
  };

  // ~-~-~-~-~-~-~-
  // Render
  // ~-~-~-~-~-~-~-
  public render() {
    const { classes } = this.props;
    return (
      <div className={this.state.hidden ? classes.hidden : classes.container}>
        <IconButton style={styles.close} onClick={() => this.onClose()}>
          <Close {...styles.icon} />
        </IconButton>
        <H3 style={styles.header}>Why do we need permission to access your Google account?</H3>
        <div className={classes.description}>
          Clockwise requests the minimum permissions needed to be able to deliver a rich calendar
          experience, for example:
        </div>
        <div className={classes.listItem}>
          <span className={classes.bullet}>•</span>
          <span className={classes.label}>View your calendar events</span>
        </div>
        <div className={classes.listItem}>
          <span className={classes.bullet}>•</span>
          <span className={classes.label}>See conference room availability</span>
        </div>
        <div className={classes.listItem}>
          <span className={classes.bullet}>•</span>
          <span className={classes.label}>
            Make sure that the meeting times we suggest work for all meeting attendees
          </span>
        </div>
        <div className={classes.learnMore}>
          Learn more by visiting our{" "}
          <A href={paths.security} target="_blank">
            security page
          </A>
          .
        </div>
      </div>
    );
  }
}

//////////////////
// WITH STYLES
//////////////////
export const AuthPermissionInfoCardStyled = withStyles(styles)(AuthPermissionInfoCardCmpt);

//////////////////
// REDUX
//////////////////
function mapStateToProps(_state: IReduxState, _ownProps: IContainer) {
  return {};
}

export const AuthPermissionInfoCard = connect(mapStateToProps, {})(AuthPermissionInfoCardStyled);
